import axiosInstance from './axiosInstance';

const housekeepingApi = {
  // Task Operations
  getMyTasks: (hotelId) => {
    return axiosInstance.get(`/Housekeeping/MyTasks`, { 
      params: { hotelId },
      headers: {
        'Content-Type': 'application/json'
      }
    });
  },

  getAllTasks: (hotelId, status = null) => {
    return axiosInstance.get(`/Housekeeping`, {
      params: { 
        hotelId,
        ...(status && { status })
      }
    });
  },

  getTaskById: (id, hotelId) => {
    return axiosInstance.get(`/Housekeeping/${id}`, {
      params: { hotelId }
    });
  },

  createTask: (taskData) => {
  const normalizeTaskType = (t) => {
    if (!t) return 'Cleaning';
    const s = String(t);
    if (s.toLowerCase() === 'roomcleaning') return 'Cleaning';
    return s;
  };

  const dto = {
    ...taskData,
    taskType: normalizeTaskType(taskData.taskType),
    notes: taskData.notes || "No notes provided"
  };

  // Post the DTO itself (no { createDto: ... } wrapper)
  return axiosInstance.post('/Housekeeping/Create', dto, {
    headers: { 'Content-Type': 'application/json' }
  });
},

  updateTask: (taskId, hotelId, updateDto) => {
  return axiosInstance.put(`/Housekeeping/${taskId}`, {
    // The entire object here will be your UpdateHousekeepingTaskDto
    status: updateDto.status,
    notes: updateDto.notes || null,
    completedAt: updateDto.completedAt || null,
    // Include other required fields as per your DTO
  }, {
    params: { hotelId } // Keep hotelId as query param if backend expects it
  });
},

  deleteTask: (id, hotelId) => {
    return axiosInstance.delete(`/Housekeeping/${id}`, {
      params: { hotelId }
    });
  },

  // Task Status Operations
  updateTaskStatus: (taskId, hotelId, newStatus) => {
    return axiosInstance.put(`/Housekeeping/${taskId}/Status`, {
      hotelId,
      newStatus
    });
  },

  completeTask: (taskId, hotelId) => {
    return axiosInstance.post(`/Housekeeping/Complete/${taskId}`, null, {
      params: { hotelId }
    });
  },

  // Assignment Operations
  assignTask: (assignData) => {
    return axiosInstance.post('/Housekeeping/Assign', {
      taskId: assignData.taskId,
      userId: assignData.userId,
      hotelId: assignData.hotelId
    });
  },

  getAssignableUsers: (hotelId) => {
    return axiosInstance.get('/Housekeeping/AssignableUsers', {
      params: { hotelId }
    });
  },

  // Checklist Operations
getChecklistItems: (taskId) => {
  return axiosInstance.get(`/Housekeeping/Checklist/${taskId}`);
},

// IMPORTANT: backend expects List<ChecklistItemDto> (array) as the BODY, not { items: [...] }
updateChecklist: (taskId, checklistItems) => {
  return axiosInstance.put(`/Housekeeping/Checklist/${taskId}`, checklistItems);
},


  // Resource Operations
  getHousekeepingStaff: (hotelId) => {
    return axiosInstance.get('/Housekeeping/Housekeepers', {
      params: { hotelId }
    });
  },

  getRooms: (hotelId) => {
    return axiosInstance.get('/Housekeeping/Rooms', {
      params: { hotelId }
    });
  },

  // QR Code Operations
  getRoomDetailsFromQR: (qrCodeData) => {
    return axiosInstance.get(`/Housekeeping/QR/${encodeURIComponent(qrCodeData)}`);
  },

  // Room Service Operations
  requestRoomService: (requestData) => {
    return axiosInstance.post('/Housekeeping/Request', requestData);
  },
createChecklistItem: (taskId, item) => axiosInstance.post(`/Housekeeping/Checklist/${taskId}`, item),
updateChecklistItem: (itemId, updateData) => axiosInstance.put(`/Housekeeping/ChecklistItem/${itemId}`, updateData),
deleteChecklistItem: (itemId) => axiosInstance.delete(`/Housekeeping/ChecklistItem/${itemId}`),

  getRoomTypes: (hotelId) => axiosInstance.get(`/hotels/${hotelId}/room-types`),

  // ─────────────────────────────────────────────────────────
  // CHECKLIST TEMPLATES (MATCHES ChecklistTemplatesController you pasted)
  // Controller:
  //  - GET    /api/checklist-templates?hotelId=&taskType=&includeGlobal=
  //  - POST   /api/hotels/{hotelId}/checklist-templates
  //  - PUT    /api/hotels/{hotelId}/checklist-templates/{templateId}
  //  - DELETE /api/hotels/{hotelId}/checklist-templates/{templateId}
  //  - POST   /api/hotels/{hotelId}/checklist-templates/adopt/{globalTemplateId}
  // ─────────────────────────────────────────────────────────
  getChecklistTemplatesLibrary: (taskType = null) =>
    axiosInstance.get(`/checklist-templates`, {
      params: {
        ...(taskType ? { taskType } : {}),
      },
    }),

  getChecklistTemplatesByHotel: (hotelId, taskType = null, includeGlobal = false) =>
    axiosInstance.get(`/checklist-templates`, {
      params: {
        hotelId,
        includeGlobal,
        ...(taskType ? { taskType } : {}),
      },
    }),

  createChecklistTemplate: (hotelId, dto) =>
    axiosInstance.post(`/hotels/${hotelId}/checklist-templates`, dto),

  updateChecklistTemplate: (hotelId, templateId, dto) =>
    axiosInstance.put(`/hotels/${hotelId}/checklist-templates/${templateId}`, dto),

  disableChecklistTemplate: (hotelId, templateId) =>
    axiosInstance.delete(`/hotels/${hotelId}/checklist-templates/${templateId}`),

  adoptChecklistTemplate: (hotelId, globalTemplateId) =>
    axiosInstance.post(`/hotels/${hotelId}/checklist-templates/adopt/${globalTemplateId}`),
};

export default housekeepingApi;
